// ** Initial State
const initialState = {
  data: [],
  total: 1,
  from: 0,
  to: 0,
  params: {},
  selectedData: null
}

const divisions = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_DATA_DIVISION':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params,
        from: action.from,
        to: action.to,
      }
    case 'GET_DIVISION':
      return { ...state, selectedData: action.selectedData }
    case 'ADD_DIVISION':
      return { ...state }
    case 'EDIT_DIVISION':
      return { ...state }
    case 'DELETE_DIVISION':
      return { ...state }
    default:
      return { ...state }
  }
}
export default divisions
